export default __webpack_public_path__ + "static/media/Photo 10 - BR - Coursives.cfe52faf.png";